<template>
  <b-container>
    <b-row class="mb-3 text-bold">
      <b-col cols="12">
        <legend class="p-3 d-flex flex-column">
          {{ question.question }} <br />
          <div class="d-flex flex-row mt-3 mx-auto">
            <div><b-icon icon="question-circle-fill"></b-icon></div>
            <div class="font-size-12 text-left ml-2 font-weight-normal">
              Aby dopasować kolejność, kliknij i przytrzymaj kursor na
              zagadnieniu. <br />
              Następnie przesuń góra-dół tak, aby znalazło się we właściwym
              miejscu.
            </div>
          </div>
        </legend>
      </b-col>
    </b-row>
    <b-row
      v-for="(answer, index) in answers"
      :key="index"
      class="my-0 mr-2 p-0 font-size-16 font-weight-bold"
    >
      <b-col cols="3" class="p-3 my-3 ml-auto mr-0 text-right">
        {{ index + 1 }}.</b-col
      >
      <b-col
        cols="9"
        class="p-0 drop-zone mx-auto"
        @drop="onDrop($event, index, answer)"
        @dragover.prevent
        @dragenter.prevent
      >
        <div
          :class="{ shine: showShine }"
          class="
            bg-white
            p-3
            rounded-lg
            border
            mr-auto
            ml-0
            my-3
            answer
            w-75
            text-left
          "
          @click="showShine = false"
          draggable="true"
          @dragstart="
            onStartDrag($event, answer, index);
            showShine = false;
          "
        >
          {{ question.answers[answer] }}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'CourseExamQuestionSorted',
  data() {
    return {
      showShine: true,
      draggedItems: [],
      answers: [],
    };
  },
  props: {
    question: {},
    questionIndex: {},
    progressCurrent: {},
    examImagesPath: {},
  },
  computed: {},
  created() {
    this.$emit('onToggleNextBtn', false);
  },
  methods: {
    setAnswers() {
      this.question.answers.forEach((answerGroup, index) => {
        this.answers.push(index);
      });
      this.answers = _.shuffle(this.answers);
    },
    isDragged(itemID) {
      return this.draggedItems.includes(itemID);
    },
    setDragged(itemID) {
      if (!this.draggedItems.includes(itemID)) {
        this.draggedItems.push(itemID);
      }
    },
    onStartDrag(evt, item, dragAnswerIndex) {
      this.setDragged(item);
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      evt.dataTransfer.setData('itemID', item);
      evt.dataTransfer.setData('dragAnswerIndex', dragAnswerIndex);
    },
    onDrop(evt, dropAnswerIndex, dropItemID) {
      this.setDragged(dropItemID);
      let newAnswers = this.answers;
      this.answers = null;
      newAnswers[dropAnswerIndex] = parseInt(
        evt.dataTransfer.getData('itemID')
      );
      newAnswers[evt.dataTransfer.getData('dragAnswerIndex')] = dropItemID;
      this.answers = newAnswers;
      this.$emit('onChangeAnswer', {
        questionIndex: this.questionIndex,
        value: this.answers,
      });
    },
  },
  mounted() {
    if (this.question.answers) {
      this.setAnswers();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .drop-zone {
    background-color: #eee;
    margin-bottom: 10px;
    padding: 10px;
  }

  .arrow {
    width: 60%;
    height: 20px;
    background: #ccc;

    &:first-child {
      margin: 38px auto;
    }
  }

  .arrow-right {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 40px solid #ccc;
    float: right;
    margin-top: -10px;
    margin-right: -40px;
  }

  .arrow-left {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    float: left;
    border-right: 40px solid #ccc;
    margin-top: -10px;
    margin-left: -40px;
  }

  legend {
    color: white !important;
    background: var(--sidebar-color) !important;
  }

  .dragged {
    background-color: #66e0d6 !important;

    &:hover {
      background: rgba(102, 224, 214, 0.7) !important;
    }
  }

  .answer {
    cursor: grab;

    &:hover {
      background: rgba(255, 255, 255, 0.5);
    }
  }

  @keyframes shining {
    50% {
      box-shadow: 0 0 5px rgba(17, 146, 168, 1);
    }
  }

  .shine {
    box-shadow: 0 0 5px rgba(17, 146, 168, 0);
    animation: shining 2s infinite linear;
  }
}
</style>
